var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12C13.933 12 15.5 10.433 15.5 8.5C15.5 6.567 13.933 5 12 5C10.067 5 8.5 6.567 8.5 8.5C8.5 10.433 10.067 12 12 12Z",
    stroke: "var(--sidebar-text-color)",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8602 19C17.9476 18.7026 18 18.3903 18 18.0632C18 15.9517 15.9898 15 13.4989 15H10.5011C8.01894 15 6 15.9517 6 18.0632C6 18.3903 6.05244 18.7026 6.13984 19",
    stroke: "var(--sidebar-text-color)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.9,
    y: 1.9,
    width: 20.2,
    height: 20.2,
    rx: 3.1,
    stroke: "var(--sidebar-text-color)",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUser);
export default __webpack_public_path__ + "static/media/ic-user.37d5dc0fd43c59357cdedb2b5f229dbf.svg";
export { ForwardRef as ReactComponent };